export const tenantJobLabel = {
  pageSize: {
    width: 283.5,
    height: 226.77
  },
  pageOrientation: 'landscape',
  pageMargins: [ 0, 27, 0, 0 ],
  info: {
    title: '',
    author: 'NDT Division GmbH, Magdeburg',
    subject: '',
    revison: 'Rev 01/2026',
  },
  background: function(currentPage: number, pageCount: number) {
    return [
      {
        svg:
          '<svg x="60" xmlns="http://www.w3.org/2000/svg" viewBox="225 32 175 50">' +
          '<style>.nj-4{fill:#1d1e1b;}.nj-5{fill:#487b9d;}</style>' +
          '<polygon class="nj-4" points="245.31 37.97 245.31 58.83 241.04 58.83 232.73 46.79 232.6 46.79 232.6 58.83 227.56 58.83 227.56 37.97 231.9 37.97 240.11 49.99 240.28 49.99 240.28 37.97 245.31 37.97"/>' +
          '<path class="nj-4" d="M253.51,54.53h2.48c1.17,0,2.16-.2,2.97-.59.81-.4,1.42-1.04,1.85-1.95.42-.9.63-2.1.63-3.6s-.21-2.7-.63-3.59c-.42-.89-1.04-1.54-1.86-1.93-.81-.4-1.83-.6-3.02-.6h-2.4v12.27h0ZM256.18,58.83h-7.71v-20.86h7.7c2.13,0,3.96.42,5.5,1.25,1.54.83,2.72,2.03,3.56,3.59.84,1.56,1.25,3.42,1.25,5.59s-.42,4.04-1.25,5.6c-.83,1.56-2.02,2.76-3.56,3.59-1.54.83-3.37,1.25-5.49,1.25h0Z"/>' +
          '<polygon class="nj-4" points="267.05 42.06 267.05 37.97 284.68 37.97 284.68 42.06 278.36 42.06 278.36 58.83 273.39 58.83 273.39 42.06 267.05 42.06"/>' +
          '<rect class="nj-5" x="292.64" y="35.5" width="3.2" height="25.92"/>' +
          '<path class="nj-4" d="M306.83,57.12h4.09c1.79,0,3.3-.35,4.5-1.06,1.2-.7,2.12-1.72,2.72-3.03.6-1.31.91-2.87.91-4.68,0-1.8-.3-3.35-.89-4.65-.59-1.3-1.46-2.29-2.61-2.98-1.15-.69-2.57-1.04-4.26-1.04h-4.46v17.44h0ZM311.03,58.83h-6.11v-20.86h6.48c1.99,0,3.69.41,5.11,1.24,1.41.83,2.5,2.02,3.25,3.57.76,1.55,1.13,3.41,1.13,5.57s-.39,4.06-1.16,5.63c-.77,1.56-1.89,2.76-3.36,3.6-1.47.84-3.25,1.25-5.34,1.25h0Z"/>' +
          '<path class="nj-4" d="M324.42,58.83v-15.65h1.83v15.64h-1.83ZM325.35,40.5c-.38,0-.69-.12-.96-.38-.27-.26-.4-.56-.4-.92s.14-.67.4-.92c.27-.26.58-.38.95-.38s.69.12.96.38c.27.26.4.56.4.92s-.14.67-.4.92c-.27.26-.58.38-.95.38"/>' +
          '<polygon class="nj-4" points="342.01 43.18 336.3 58.83 334.36 58.83 328.65 43.18 330.62 43.18 335.26 56.43 335.4 56.43 340.05 43.18 342.01 43.18"/>' +
          '<path class="nj-4" d="M344.42,58.83v-15.65h1.83v15.64h-1.83ZM345.35,40.5c-.38,0-.69-.12-.96-.38-.27-.26-.4-.56-.4-.92s.14-.67.4-.92c.27-.26.58-.38.95-.38s.69.12.96.38c.27.26.4.56.4.92s-.14.67-.4.92c-.27.26-.58.38-.95.38"/>' +
          '<path class="nj-4" d="M360.42,46.62l-1.66.47c-.16-.47-.39-.89-.69-1.27-.3-.38-.69-.68-1.17-.91-.48-.22-1.07-.33-1.78-.33-1.06,0-1.93.25-2.61.76-.68.51-1.02,1.15-1.02,1.95,0,.67.23,1.22.7,1.63s1.18.75,2.15.99l2.36.58c1.31.32,2.3.82,2.95,1.52.65.69.98,1.57.98,2.61,0,.88-.24,1.67-.73,2.35-.49.68-1.17,1.22-2.04,1.62-.88.39-1.88.58-3.03.58-1.53,0-2.79-.34-3.78-1.03-1-.69-1.63-1.69-1.9-2.99l1.74-.43c.22.93.66,1.63,1.32,2.11.66.47,1.52.71,2.59.71,1.2,0,2.17-.27,2.88-.81.72-.54,1.08-1.22,1.08-2.03,0-.63-.21-1.16-.63-1.6-.42-.43-1.06-.75-1.91-.95l-2.55-.61c-1.36-.32-2.36-.84-3.01-1.55-.65-.71-.98-1.58-.98-2.63,0-.86.23-1.62.7-2.28.47-.66,1.12-1.17,1.93-1.54.82-.38,1.76-.56,2.81-.56,1.43,0,2.58.32,3.44.98.86.65,1.48,1.54,1.86,2.67h.01Z"/>' +
          '<path class="nj-4" d="M363.48,58.83v-15.65h1.83v15.64h-1.83ZM364.41,40.5c-.38,0-.69-.12-.96-.38-.27-.26-.4-.56-.4-.92s.14-.67.4-.92c.27-.26.58-.38.95-.38s.69.12.96.38c.27.26.4.56.4.92s-.14.67-.4.92c-.27.26-.58.38-.95.38"/>' +
          '<path class="nj-4" d="M375.05,57.5c1.08,0,2.01-.29,2.76-.88s1.32-1.36,1.71-2.33c.39-.97.58-2.04.58-3.21s-.19-2.24-.58-3.22c-.39-.98-.96-1.76-1.71-2.35-.75-.59-1.67-.89-2.76-.89s-2,.3-2.75.89c-.76.59-1.33,1.38-1.72,2.35-.39.97-.58,2.05-.58,3.22s.19,2.24.58,3.21c.39.97.96,1.75,1.71,2.33.75.58,1.67.88,2.76.88ZM375.05,59.16c-1.35,0-2.55-.34-3.58-1.03-1.04-.68-1.85-1.63-2.43-2.85s-.88-2.61-.88-4.2.29-3.01.88-4.23c.58-1.22,1.39-2.17,2.43-2.85,1.04-.68,2.23-1.02,3.58-1.02s2.55.35,3.58,1.03c1.03.68,1.84,1.64,2.43,2.85.59,1.22.88,2.62.88,4.23s-.29,2.99-.88,4.2-1.39,2.16-2.43,2.85c-1.04.69-2.23,1.03-3.58,1.03"/>' +
          '<path class="nj-4" d="M386.58,49.05v9.78h-1.82v-15.65h1.76v2.46h.16c.37-.8.94-1.45,1.72-1.93.78-.48,1.74-.73,2.89-.73,1.05,0,1.98.22,2.77.66.8.44,1.42,1.08,1.86,1.93.44.85.67,1.89.67,3.13v10.13h-1.82v-10.02c0-1.28-.36-2.3-1.07-3.04-.71-.75-1.67-1.12-2.88-1.12-.82,0-1.55.18-2.19.53-.64.35-1.14.86-1.51,1.52-.37.66-.55,1.45-.55,2.36h0Z"/>' +
          '</svg>',
        fit: [ 200, 57 ]
      }
    ]
  },
  content: [
    {
      layout: 'noBorders',
      table: {
        headerRows: 0,
        widths: [ 'auto', 'auto' ],
        body: [
          [ { text: 'Job NDT:', style: 'fett' }, { text: '96.0001.0001.1' } ],
          [ { text: 'Best.-Nr. Knd:', style: 'fett' }, { text: '0049/NDT/00000001' } ],
          [ { text: 'Bauteilname:', style: 'fett' }, { text: 'Musterbauteil geschweißt' } ],
          [ { text: 'Menge:', style: 'fett' }, { text: '1' } ],
          [ { text: 'Zeichnungsnr.:', style: 'fett' }, { text: 'DWG-2026-001 Ausgabe 01 / 05-26' } ],
          [ { text: 'Material:', style: 'fett' }, { text: 'S355J2, 1.0577 +N' } ],
          [ { text: 'Charge:', style: 'fett' }, { text: '' } ],
          [ { text: 'Ser.-Nr.:', style: 'fett' }, { text: '' } ]
        ]
      },
      style: 'normal',
      margin: [ 20, 5 ]
    },
    {
      table: {
        headerRows: 1,
        widths: [ '30%', '35%', '35%' ],
        body: [
          [
            { text: '' }, { text: 'Datum' }, { text: 'Unterschrift' },
          ],
          [ { text: 'Freigabe' }, ' ', ' ' ],
          [ { text: 'Sperrung' }, ' ', ' ' ],
          [ [ 'Freigabe', { text: 'nach Sperrung', style: 'small' } ], ' ', ' ' ]
        ]
      },
      style: 'table',
      margin: [ 20, 0 ]
    },
  ],

  styles: {
    header: {
      fontSize: 10,
      bold: true
    },
    table: {
      fontSize: 9,
      bold: false
    },
    normal: {
      fontSize: 9,
      bold: false
    },
    fett: {
      fontSize: 9,
      bold: true
    },
    small: {
      fontSize: 6,
      bold: false
    }
  }
};
